import { SellerFilterOption } from '@/components/SellerFilter/SellerFilterUi';
import { SellersResponse } from '@/data/api/model/sellers/SellersDto';

export const sellersResponseToSellerFilterOptions = (
  response: SellersResponse | undefined
): SellerFilterOption[] => {
  if (!response) return [];
  return (
    response.data?.map((input) => ({
      sellerId: input.business_id,
      sellerName: input.business_name,
    })) ?? []
  );
};
